import type { DateIso, Phase } from '../../types/domain';
import { contractPeriodEnd, contractTotalMonths, dateFromIso, isoStr } from '../dates';

// Même jour n mois plus tard, ramené au dernier jour du mois s'il n'existe pas (31/01 → 28/02).
function sameDayLater(iso: DateIso, months: number): DateIso {
  const d = dateFromIso(iso);
  const lastDay = new Date(d.getFullYear(), d.getMonth() + months + 1, 0).getDate();
  return isoStr(new Date(d.getFullYear(), d.getMonth() + months, Math.min(d.getDate(), lastDay)));
}

/** Fin de la phase prolongée de `months` mois. Une fin calée sur les mois du contrat (début +
    k mois − 1 jour) le reste, pour que l'engagement reporté sur l'affaire tombe juste ; sinon,
    même jour n mois plus tard. */
export function extendedEnd(phase: Phase, months: number): DateIso {
  const end = phase.dateFin as DateIso;
  const start = phase.dateDebut;
  const total = start ? contractTotalMonths(start, end) : 0;
  if (start && total && isoStr(contractPeriodEnd(dateFromIso(start), total)) === end)
    return isoStr(contractPeriodEnd(dateFromIso(start), total + months));
  return sameDayLater(end, months);
}

/** Engagement de la ligne vendue avant et après une nouvelle fin (mois entamés), ou null sans
    date de début. */
export function engagementChange(
  phase: Phase,
  newEnd: DateIso,
): { before: number; after: number } | null {
  if (!phase.dateDebut || !phase.dateFin) return null;
  return {
    before: contractTotalMonths(phase.dateDebut, phase.dateFin),
    after: contractTotalMonths(phase.dateDebut, newEnd),
  };
}
